export const handleHashScroll = (hashId: string) => {
  const element = document.getElementById(hashId)
  return element?.scrollIntoView({
    behavior: 'smooth',
  })
}
